/* ÉclatDent : accueil cinématique v2 (gabarit index.cinematique, EN TEST).
   1. Panier : boutons [data-edc-add] (variante), /cart/add.js puis l'événement cart:refresh (tous modes). Copie du code e-mail.
   2. Mode cinéma (html.edc-cine, posé avant le rendu par ed-cine-ouverture) : le défilement devient une ligne de temps T
      (une unité par scène, ordre du gabarit) lissée avec inertie ; chaque calque fixe se relaie (--vis) ; chaque scène a sa
      couleur de fond (teinte du tube actif dans « habitudes ») et le texte passe en clair sur les fonds sombres (data-edc-tone).
   3. 3D (html.edc-can3d) : three.js r159 + ed-cine-3d.js chargés au PREMIER geste du visiteur (ou 1,8 s après « load » sur
      ordinateur), jamais pendant le premier rendu ; une seule toile WebGL, rendu suspendu hors zone et onglet masqué.
   4. Vidéos : source posée seulement quand la scène approche, lecture muette quand elle est à l'écran, pause sinon. */
(() => {
  const html = document.documentElement;
  const scenes = [...document.querySelectorAll('[data-edc-scene]')];
  if (!scenes.length) return;
  html.classList.add('edc-js');
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* 1. Panier et code */
  document.addEventListener('click', async (e) => {
    const cp = e.target.closest('[data-edc-copy]');
    if (cp) {
      try { await navigator.clipboard.writeText(cp.dataset.edcCopy); cp.querySelector('[data-edc-copy-label]').textContent = cp.dataset.copied; } catch (err) {}
      return;
    }
    const btn = e.target.closest('[data-edc-add]');
    if (!btn) return;
    const label = btn.textContent;
    const msg = btn.parentElement.querySelector('[data-edc-msg]');
    btn.disabled = true;
    if (msg) msg.textContent = '';
    try {
      const r = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.dataset.edcAdd), quantity: 1 }] }),
      });
      if (!r.ok) throw new Error(String(r.status));
      btn.classList.add('is-done');
      btn.textContent = btn.dataset.added;
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      setTimeout(() => { btn.classList.remove('is-done'); btn.textContent = label; btn.disabled = false; }, 2400);
    } catch (err) {
      if (msg) msg.textContent = btn.dataset.fail;
      btn.disabled = false;
    }
  });

  const idx = Object.fromEntries(scenes.map((s, i) => [s.dataset.edcScene, i]));
  const sceneEl = (n) => scenes[idx[n]];
  const hab = sceneEl('habitudes');
  const needs = hab ? [...hab.querySelectorAll('[data-edc-need]')] : [];
  const tabs = hab ? [...hab.querySelectorAll('[data-edc-tab]')] : [];
  const choices = [...document.querySelectorAll('[data-edc-choice]')];
  const vids = [...document.querySelectorAll('[data-edc-video]')];

  const cine = html.classList.contains('edc-cine');
  const stage = document.querySelector('[data-edc-stage]');

  // Vidéos en mode flux : chargement à l'approche (IntersectionObserver), lecture muette à l'écran
  const arm = (v) => { if (!v.src && v.dataset.src) { v.src = v.dataset.src; v.preload = 'metadata'; } };
  if (!cine || !stage) {
    if ('IntersectionObserver' in window && vids.length) {
      const io = new IntersectionObserver((es) => es.forEach((en) => {
        const v = en.target;
        if (en.isIntersecting) { arm(v); if (!matchMedia('(prefers-reduced-motion: reduce)').matches) v.play().catch(() => {}); } else v.pause();
      }), { rootMargin: '200px 0px' });
      vids.forEach((v) => io.observe(v));
    }
    // Routeur en mode flux : simple ancre vers le besoin
    choices.forEach((b) => b.addEventListener('click', () => { const n = needs[Number(b.dataset.edcChoice)]; if (n) n.scrollIntoView({ behavior: 'smooth', block: 'center' }); }));
    return;
  }

  const backdrop = stage.querySelector('.edc-backdrop');
  const canvas = stage.querySelector('[data-edc-canvas]');
  const rail = document.querySelector('.edc-rail');
  // sommaire construit d'après l'ordre réel des scènes du gabarit (libellé : data-edc-label)
  const railList = rail && rail.querySelector('ol');
  if (railList && !railList.children.length) scenes.forEach((s, i) => {
    const li = document.createElement('li'), a = document.createElement('a');
    a.href = '#' + s.id; a.dataset.edcRail = String(i); a.textContent = s.dataset.edcLabel || ''; li.appendChild(a); railList.appendChild(li);
  });
  const railLinks = rail ? [...rail.querySelectorAll('[data-edc-rail]')] : [];
  const layers = scenes.map((s) => s.querySelector('.edc-layer'));
  const LAST = scenes.length - 1;
  const habImgs = hab ? [...hab.querySelectorAll('.edc-visual img')] : [];
  const conf = sceneEl('confiance');
  const facts = conf ? [...conf.querySelectorAll('[data-edc-fact]')] : [];
  const finalLayer = layers[LAST];
  const bro = sceneEl('brosses');
  // titres des scènes (sauf l'ouverture, qui porte le LCP) : chaque mot monte de derrière un masque, en décalé
  scenes.slice(1).forEach((sc) => sc.querySelectorAll('.edc-h').forEach((h) => {
    if (h.dataset.split) return; h.dataset.split = '1';
    const words = h.textContent.trim().split(/\s+/);
    h.setAttribute('aria-label', h.textContent.trim());
    h.innerHTML = words.map((w, i) => '<span class="edc-w" aria-hidden="true" style="--i:' + i + '"><span>' + w.replace(/[&<>]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c])) + '</span></span>').join(' ');
  }));

  const clamp = (v, a = 0, b = 1) => Math.min(b, Math.max(a, v));
  const sstep = (a, b, v) => { const t = clamp((v - a) / (b - a)); return t * t * (3 - 2 * t); };
  const H0 = 0.06, H1 = 0.92;
  const needF = (p) => clamp((p - H0) / (H1 - H0)) * Math.max(0, needs.length - 1);
  const is = idx.strass ?? -9;
  const nightAt = (T) => sstep(is - 0.2, is + 0.05, T) * (1 - sstep(is + 0.86, is + 1.08, T));

  /* Couleurs de fond par scène (DA : bleus de marque, nuit profonde, teintes douces tirées de chaque tube).
     bg = fond, gl = halo derrière l'objet, ga = intensité du halo. Le ton du texte se déduit de la luminance du fond. */
  const hex = (h) => [1, 3, 5].map((i) => parseInt(h.slice(i, i + 2), 16) / 255);
  const C = (bg, gl, ga) => ({ bg: hex(bg), gl: hex(gl), ga });
  const PAL = {
    ouverture: C('#F3F8FF', '#FFFFFF', 0.95),
    probleme: C('#E6EFFB', '#FFFFFF', 0.9),
    geste: C('#0F2547', '#4A90E2', 0.42),
    brosses: C('#123A6B', '#6FB0FF', 0.45),
    videos: C('#0A1832', '#2C5AA0', 0.5),
    strass: C('#08142B', '#4A90E2', 0.36),
    confiance: C('#F8FBFF', '#FFFFFF', 0.95),
    faq: C('#E9F1FB', '#FFFFFF', 0.85),
    email: C('#2C5AA0', '#4A90E2', 0.6),
    final: C('#F1F7F3', '#FFFFFF', 0.95),
  };
  const NEED = {
    cafe: C('#0E3A2B', '#3A9E66', 0.5),   // vert café
    tabac: C('#13284A', '#7FA9DE', 0.45), // bleu acier (tube argent)
    haleine: C('#0B3A47', '#4FB8C9', 0.45), // bleu menthe
    eclat: C('#E7ECF2', '#FFFFFF', 0.95), // gris clair : le tube noir charbon ressort
  };
  const needPal = needs.map((n) => NEED[n.dataset.edcBesoin] || PAL.probleme);
  const mixC = (a, b, t) => ({ bg: a.bg.map((v, i) => v + (b.bg[i] - v) * t), gl: a.gl.map((v, i) => v + (b.gl[i] - v) * t), ga: a.ga + (b.ga - a.ga) * t });
  function palAt(name, p) {
    if (name === 'habitudes' && needPal.length) {
      const f = needF(p), i = Math.floor(f), w = sstep(0.25, 0.75, f - i);
      return mixC(needPal[Math.min(i, needPal.length - 1)], needPal[Math.min(i + 1, needPal.length - 1)], w);
    }
    return PAL[name] || PAL.ouverture;
  }
  const NAMES = scenes.map((s) => s.dataset.edcScene);
  function palette(t) {
    const sc = Math.min(LAST, Math.floor(t)), p = clamp(t - sc);
    const a = palAt(NAMES[sc], p);
    if (sc < LAST && p > 0.8) return mixC(a, palAt(NAMES[sc + 1], 0), sstep(0.8, 1, p));
    return a;
  }
  const lum = (c) => 0.2126 * c[0] ** 2.2 + 0.7152 * c[1] ** 2.2 + 0.0722 * c[2] ** 2.2;
  const css = (c, a) => 'rgba(' + c.map((v) => Math.round(v * 255)).join(',') + (a == null ? ',1)' : ',' + a.toFixed(3) + ')');

  /* Géométrie du défilement */
  let tops = [], lens = [], vh = innerHeight, endScroll = 0;
  function measure() {
    vh = innerHeight;
    const y = scrollY;
    tops = scenes.map((s) => s.getBoundingClientRect().top + y);
    lens = scenes.map((s, i) => Math.max(1, s.offsetHeight - (i === LAST ? vh : 0)));
    endScroll = tops[LAST] + lens[LAST];
    const narrow = innerWidth <= 760;
    stage.style.setProperty('--edc-ax', narrow ? '50%' : '68%');
    stage.style.setProperty('--edc-ay', narrow ? '28%' : '47%');
    if (three) three.resize();
  }
  function rawT() {
    const y = scrollY;
    if (y <= tops[0]) return 0;
    for (let i = LAST; i >= 0; i--) if (y >= tops[i]) return Math.min(i + 1, i + (y - tops[i]) / lens[i]);
    return 0;
  }

  let T = 0, Ts = 0, last = 0, raf = 0, three = null, stageOn = true, curScene = -1, curNeed = 0, tone = '', frozen = null, hover = null;
  let px = 0, py = 0;

  function setVideos(t) {
    const iv = idx.videos;
    if (iv == null) return;
    const near = Math.abs(t - iv - 0.5) < 1.35, on = t > iv + 0.04 && t < iv + 0.96;
    vids.forEach((v) => {
      if (near) arm(v);
      if (on && v.src) { if (v.paused && v.dataset.vis !== '0') v.play().catch(() => {}); } else if (!v.paused) v.pause();
    });
  }

  function apply(t, dt) {
    const y = scrollY;
    const over = y - endScroll;
    const on = over < vh;
    if (on !== stageOn) { stageOn = on; stage.classList.toggle('is-off', !on); if (rail) rail.classList.toggle('is-off', !on); }
    const shift = over > 0 ? 'translate3d(0,' + (-over).toFixed(1) + 'px,0)' : '';
    stage.style.transform = shift;
    if (finalLayer) finalLayer.style.transform = shift;

    for (let i = 0; i <= LAST; i++) {
      const p = clamp(t - i);
      let vis;
      if (i === 0) vis = 1 - sstep(0.84, 0.98, p);
      else if (i === LAST) vis = t < i ? 0 : sstep(0.02, 0.14, p);
      else vis = t < i || t > i + 1 ? 0 : sstep(0.02, 0.14, p) * (1 - sstep(0.84, 0.98, p));
      if (!on && i !== LAST) vis = 0;
      const s = scenes[i];
      s.style.setProperty('--vis', vis.toFixed(3));
      s.style.setProperty('--p', p.toFixed(3));
      layers[i].classList.toggle('is-on', vis > 0.01);
      layers[i].classList.toggle('is-near', Math.abs(t - i - 0.5) < 1.35);
    }
    const sc = Math.min(LAST, Math.floor(t));
    if (sc !== curScene) {
      curScene = sc;
      railLinks.forEach((a, i) => (i === sc ? a.setAttribute('aria-current', 'step') : a.removeAttribute('aria-current')));
    }
    if (hab) {
      const k = Math.round(needF(clamp(t - idx.habitudes)));
      if (k !== curNeed) {
        curNeed = k;
        needs.forEach((n, i) => n.classList.toggle('is-on', i === k));
        tabs.forEach((b, i) => b.setAttribute('aria-pressed', i === k ? 'true' : 'false'));
        habImgs.forEach((im, i) => im.classList.toggle('is-on', i === k));
      }
    }
    if (conf) { const pc = clamp(t - idx.confiance); facts.forEach((f, i) => f.classList.toggle('is-on', pc >= 0.1 + i * 0.16)); }
    if (bro) bro.style.setProperty('--fan', sstep(0.32, 0.62, clamp(t - idx.brosses)).toFixed(3));
    setVideos(t);

    const pal = palette(t);
    backdrop.style.setProperty('--edc-bg', css(pal.bg));
    backdrop.style.setProperty('--edc-glowc', css(pal.gl, pal.ga));
    const dark = lum(pal.bg) < 0.25;
    const tn = dark ? 'dark' : 'light';
    if (tn !== tone) { tone = tn; html.setAttribute('data-edc-tone', tn); }
    if (three && on) three.render(t, dt, { night: nightAt(t), dark: 1 - clamp(lum(pal.bg) * 1.4), bg: pal.bg, gl: pal.gl, ga: pal.ga, px, py, hover, needF: needF(clamp(t - (idx.habitudes ?? 0))) });
  }

  function frame(now) {
    raf = 0;
    const dt = last ? Math.min(0.05, (now - last) / 1000) : 1 / 60;
    last = now;
    T = frozen == null ? rawT() : frozen;
    Ts += (T - Ts) * (1 - Math.exp(-dt * 6.5));
    if (Math.abs(T - Ts) < 0.0005) Ts = T;
    apply(Ts, dt);
    if (Ts !== T || (three && stageOn && !document.hidden)) raf = requestAnimationFrame(frame);
    else last = 0;
  }
  const kick = () => { if (!raf) raf = requestAnimationFrame(frame); };

  measure();
  Ts = T = rawT();
  apply(Ts, 0);
  addEventListener('scroll', kick, { passive: true });
  addEventListener('resize', () => { measure(); kick(); });
  addEventListener('load', () => { measure(); kick(); });
  document.addEventListener('visibilitychange', kick);
  if ('ResizeObserver' in window) new ResizeObserver(() => { measure(); kick(); }).observe(document.body);

  const goNeed = (k) => {
    if (idx.habitudes == null) return;
    const n = Math.max(1, needs.length - 1);
    scrollTo({ top: tops[idx.habitudes] + (H0 + ((H1 - H0) * k) / n) * lens[idx.habitudes] + 2, behavior: 'smooth' });
  };
  tabs.forEach((b, k) => b.addEventListener('click', () => goNeed(k)));
  // Routeur : survol ou focus = le tube correspondant se lève ; clic = on descend jusqu'à son tube
  choices.forEach((b) => {
    const k = Number(b.dataset.edcChoice);
    b.addEventListener('pointerenter', () => { hover = k; kick(); });
    b.addEventListener('pointerleave', () => { hover = null; kick(); });
    b.addEventListener('focus', () => { hover = k; kick(); });
    b.addEventListener('blur', () => { hover = null; kick(); });
    b.addEventListener('click', () => goNeed(k));
  });
  // Clavier : un élément qui reçoit le focus dans une scène hors champ amène la page sur cette scène
  scenes.forEach((s, i) => s.addEventListener('focusin', (e) => {
    if (e.target.matches('input, textarea')) { frozen = i + 0.5; return; } // clavier mobile : on fige la scène pendant la saisie
    if (Math.floor(Ts) === i || (i === LAST && Ts >= LAST)) return;
    scrollTo({ top: tops[i] + (i === 0 ? 0 : lens[i] * 0.2), behavior: 'auto' });
  }));
  scenes.forEach((s) => s.addEventListener('focusout', (e) => {
    if (!e.target.matches('input, textarea')) return;
    setTimeout(() => { if (!document.activeElement || !document.activeElement.matches('input, textarea')) { const i = frozen; frozen = null; if (i != null) scrollTo({ top: tops[Math.floor(i)] + lens[Math.floor(i)] * 0.5, behavior: 'auto' }); kick(); } }, 300);
  }));
  railLinks.forEach((a, i) => a.addEventListener('click', (e) => {
    e.preventDefault();
    scrollTo({ top: tops[i] + (i === 0 ? 0 : lens[i] * 0.2), behavior: 'smooth' });
  }));
  // Retour du formulaire e-mail (?customer_posted=true) : on rouvre la page sur la scène du code
  if (/customer_posted=true/.test(location.search) && idx.email != null) addEventListener('load', () => { measure(); scrollTo(0, tops[idx.email] + lens[idx.email] * 0.5); kick(); });
  // Bande vidéo mobile : seule la vidéo visible joue
  if ('IntersectionObserver' in window && vids.length) {
    const io = new IntersectionObserver((es) => es.forEach((en) => { en.target.dataset.vis = en.intersectionRatio > 0.6 ? '1' : '0'; if (en.intersectionRatio <= 0.6) en.target.pause(); else kick(); }), { threshold: [0, 0.6, 1] });
    vids.forEach((v) => io.observe(v));
  }

  /* 3. 3D différée */
  if (!html.classList.contains('edc-can3d') || !canvas) return;
  if (matchMedia('(pointer: fine)').matches) {
    addEventListener('pointermove', (e) => { px = (e.clientX / innerWidth) * 2 - 1; py = (e.clientY / innerHeight) * 2 - 1; kick(); }, { passive: true });
  }
  const loadScript = (src) => new Promise((ok, ko) => { const s = document.createElement('script'); s.src = src; s.async = true; s.onload = ok; s.onerror = ko; document.head.appendChild(s); });
  let started = false;
  const EVS = ['scroll', 'wheel', 'pointerdown', 'pointermove', 'touchstart', 'keydown'];
  function start() {
    if (started) return;
    started = true;
    EVS.forEach((ev) => removeEventListener(ev, start));
    const texOf = (role) => [...document.querySelectorAll('[data-edc-role="' + role + '"]')].map((el) => el.dataset.edcTex);
    loadScript(stage.dataset.three)
      .then(() => loadScript(stage.dataset.scene))
      .then(() => {
        if (!window.EDCine3D) return;
        three = window.EDCine3D(canvas, {
          hero: texOf('hero')[0], carousel: texOf('carousel'), trio: texOf('trio')[0],
          scenes: idx,
          onReady: () => { html.classList.add('edc-3d'); kick(); },
          onLost: () => { html.classList.remove('edc-3d'); three = null; },
        });
        if (three) { three.resize(); kick(); }
      })
      .catch(() => {});
  }
  EVS.forEach((ev) => addEventListener(ev, start, { passive: true }));
  if (matchMedia('(pointer: fine)').matches) {
    const later = () => setTimeout(start, 1800);
    if (document.readyState === 'complete') later(); else addEventListener('load', later, { once: true });
  }
})();
